"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import classNames from "classnames";
import Account from "../../api/account";
import { activeTypes } from "../../formatters/documents";
function documentTypeTransformer(props) {
  return props.documentTypesTransformer || _.identity;
}
function setType(props, type, type_name) {
  props.onTypeSet(props.document, type, type_name);
}
function transformedActiveTypes(props) {
  return documentTypeTransformer(props)(activeTypes());
}
function typeSelector(props, type, index) {
  var doc = props.document;
  var classes = classNames({
    selected: doc.type === type.value,
    guessed: doc.data && doc.data.document_type === type.value,
    "document-indexer__type": true
  });
  var showHotkeyHint = Account.useDocumentTypeHotkeys() && index < 9;
  return /* @__PURE__ */ jsxs(
    "a",
    {
      className: classes,
      onClick: () => {
        setType(props, type.value, type.name);
      },
      children: [
        type.name,
        showHotkeyHint ? /* @__PURE__ */ jsx("span", { className: "document-indexer__hotkey-hint", children: index + 1 }) : null
      ]
    },
    type.value
  );
}
function handleKeydown(props, e) {
  if (!Account.useDocumentTypeHotkeys()) {
    return;
  }
  const target = e.target;
  const tagName = target.tagName.toLowerCase();
  const isInput = tagName === "input" || tagName === "textarea" || tagName === "select";
  if (isInput) {
    return;
  }
  const key = e.key;
  const types = transformedActiveTypes(props);
  let type = null;
  if (key === "Enter") {
    const doc = props.document;
    const suggested = doc.data.document_type;
    type = types.find((type2) => type2.value === suggested);
    props.handleEnterPress(type);
  } else if (/^[0-9]$/i.test(key)) {
    const digit = parseInt(key);
    type = types[digit - 1];
    if (type) {
      setType(props, type.value, type.name);
    }
  }
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    // Set in componentDidMount, which always runs before componentWillUnmount
    __publicField(this, "keydownListener");
  }
  render() {
    return /* @__PURE__ */ jsx("div", { children: _.map(
      transformedActiveTypes(this.props),
      (type, index) => typeSelector(this.props, type, index)
    ) });
  }
  componentDidMount() {
    this.keydownListener = (e) => handleKeydown(this.props, e);
    window.addEventListener("keydown", this.keydownListener);
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.keydownListener);
  }
}
